var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93934 8.78115C1.71163 8.28574 1.71163 7.71422 1.93934 7.21881C2.99341 4.9256 5.31073 3.33331 7.99996 3.33331C10.6892 3.33331 13.0065 4.9256 14.0606 7.21881C14.2883 7.71422 14.2883 8.28575 14.0606 8.78116C13.0065 11.0744 10.6892 12.6666 7.99996 12.6666C5.31073 12.6666 2.99341 11.0744 1.93934 8.78115Z",
    stroke: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 7.99998C9.99996 9.10455 9.10453 9.99998 7.99996 9.99998C6.89539 9.99998 5.99996 9.10455 5.99996 7.99998C5.99996 6.89541 6.89539 5.99998 7.99996 5.99998C9.10453 5.99998 9.99996 6.89541 9.99996 7.99998Z",
    stroke: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5abe52cd1cc0ee1b576e9f0a1539379c.svg";
export { ForwardRef as ReactComponent };